export default __webpack_public_path__ + "static/media/mode-4.ba5dc4e2.svg";